import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import i18n from '../../app/i18n';

const filters = [
  { label: i18n.t('shared:timeFilter.oneDay'), filterTime: 1 },
  { label: i18n.t('shared:timeFilter.oneWeek'), filterTime: 7 },
  { label: i18n.t('shared:timeFilter.oneMonth'), filterTime: 30 },
  { label: i18n.t('shared:timeFilter.threeMonths'), filterTime: 90 },
  { label: i18n.t('shared:timeFilter.oneYear'), filterTime: 365 },
  { label: i18n.t('shared:timeFilter.allTime'), filterTime: null },
];

const FilterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 600;
  margin: 11px 18px;
`;

const FilterTab = styled.div`
  color: ${props =>
    props.active
      ? themeGet('colors.primary.100')
      : themeGet('colors.black.80')};
  cursor: pointer;
`;

const TimeFilter = ({ onFilterChange, activeFilter }) => {
  return (
    <FilterWrapper>
      {filters.map(filter => (
        <FilterTab
          onClick={() => onFilterChange(filter.filterTime)}
          key={filter.label}
          active={filter.filterTime === activeFilter}
        >
          {filter.label}
        </FilterTab>
      ))}
    </FilterWrapper>
  );
};

export default TimeFilter;
